import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, UrlModule, provideConfig } from '@spartacus/core'
import { SpinnerModule } from '@spartacus/storefront'
import { UserPermissionsGuard } from '../../../../../guards/user-permissions.guard'
import { MaterialModule } from '../../../../shared/material.module'
import { SharedModule } from '../../../../shared/shared.module'
import { cancelDispenserAgreementLayoutConfig } from '../cancel-dispenser-agreement-modal/cancel-dispenser-agreement-modal-layout.config'
import { updateDispenserAgreementInfoLayoutConfig } from '../update-dispenser-agreement-info-modal/update-dispenser-agreement-info-modal-layout.config'
import { DispenserAgreementHistoryComponent } from './dispenser-agreement-history.component'

@NgModule({
  declarations: [DispenserAgreementHistoryComponent],
  imports: [RouterModule, UrlModule, SharedModule, SpinnerModule, MaterialModule],
  providers: [
    provideConfig(updateDispenserAgreementInfoLayoutConfig),
    provideConfig(cancelDispenserAgreementLayoutConfig),
    provideConfig({
      cmsComponents: {
        DispenserAgreementsComponent: {
          component: DispenserAgreementHistoryComponent,
          guards: [UserPermissionsGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class DispenserAgreementHistoryModule {}
